var map = {
	"./AUS_2_summary_score.geojson": 7920,
	"./BEL_2_summary_score.geojson": 3836,
	"./BRA_2_summary_score.geojson": 5168,
	"./CAN_2_Nunavut_summary_score.geojson": 2971,
	"./CAN_2_summary_score.geojson": 731,
	"./CHN_2_summary_score.geojson": 8684,
	"./DEU_2_summary_score.geojson": 4339,
	"./DNK_2_summary_score.geojson": 520,
	"./ESP_2_summary_score.geojson": 9677,
	"./FRA_2_summary_score.geojson": 8204,
	"./GBR_3_summary_score.geojson": 6655,
	"./IND_2_summary_score.geojson": 7502,
	"./JPN_3_summary_score.geojson": 4764,
	"./NLD_2_summary_score.geojson": 4995,
	"./SWE_2_summary_score.geojson": 7594,
	"./USA_2_summary_score.geojson": 8968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8672;